<script>
  import { Route,Router } from "svelte-routing";
  import LandingPage from './LandingPage.svelte';
</script>

<Router basepath={window.CONFIG.basepath}>
  <Route path="/" component="{LandingPage}" />
  <Route path="/:lang" component="{LandingPage}" />
</Router>
